import React from 'react';
import { groupBy, sortBy, get } from 'lodash';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './AccessBackOfficePermission.css';
import Menu from './Menu';

class AccessBackOfficePermission extends React.Component {
  render() {
    const { roleDetail, permissions, hideUnassignablePermissions } = this.props;
    const subMenuOf = groupBy(
      sortBy(permissions, 'priority_rank'),
      'menu_name'
    );
    const isManagerRole =
      this.props.roleDetail !== null && this.props.roleDetail.level === 2;
    return (
      <div className={`row ${styles.container}`}>
        <div className="col-lg-1" />
        <div className="col-lg-12">
          <div className="row">
            {hideUnassignablePermissions
              ? Object.entries(subMenuOf).reduce(
                  (currentList, [key, submenus]) => {
                    const roleDetailLevel = get(roleDetail, 'level', 3);
                    if (submenus.every(m => m.level < roleDetailLevel)) {
                      return currentList;
                    }
                    currentList.push(
                      <Menu
                        menu={key}
                        fields={this.props.fields}
                        submenu={submenus.filter(
                          m => m.level >= roleDetailLevel
                        )}
                        isOwner={this.props.isOwner}
                        roleDetail={this.props.roleDetail}
                      />
                    );
                    return currentList;
                  },
                  []
                )
              : Object.keys(subMenuOf).reduce((currentList, key) => {
                  if (!isManagerRole && key.toUpperCase() === 'EMPLOYEES') {
                    return currentList;
                  }
                  currentList.push(
                    <Menu
                      menu={key}
                      fields={this.props.fields}
                      submenu={subMenuOf[key]}
                      isOwner={this.props.isOwner}
                      roleDetail={this.props.roleDetail}
                    />
                  );
                  return currentList;
                }, [])}
          </div>
        </div>
      </div>
    );
  }
}

const mapFlagsToProps = flags => ({
  hideUnassignablePermissions: flags.hideUnassignablePermissions,
});

export default withFeatureFlags(mapFlagsToProps)(AccessBackOfficePermission);
